
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 0C114.8 0 0 114.8 0 256s114.8 256 256 256 256-114.8 256-256S397.2 0 256 0zm0 477.8c-22.9 0-44.9-3.5-65.7-9.9 9-14.7 22.6-38.9 27.6-58.1 2.7-10.4 13.8-52.7 13.8-52.7 7.2 13.8 28.4 25.5 50.8 25.5 66.9 0 115.1-61.5 115.1-138 0-73.3-59.8-128.1-136.7-128.1-95.7 0-146.5 64.3-146.5 134.2 0 32.5 17.3 73 45 85.9 4.2 2 6.4 1.1 7.4-3 .7-3.1 4.5-18.1 6.2-25.2.5-2.2.3-4.2-1.5-6.4-9.2-11.1-16.5-31.6-16.5-50.6 0-48.9 37-96.3 100.1-96.3 54.5 0 92.6 37.1 92.6 90.2 0 60-30.3 101.6-69.7 101.6-21.8 0-38.1-18-32.8-40.1 6.3-26.4 18.4-54.8 18.4-73.8 0-17-9.1-31.2-28.1-31.2-22.3 0-40.1 23-40.1 53.9 0 19.6 6.6 32.9 6.6 32.9s-22 92.9-26 110.2c-4.5 19.2-2.7 46.1-.8 63.6C92.7 430.2 34.2 350 34.2 256c0-122.5 99.3-221.8 221.8-221.8S477.8 133.5 477.8 256c0 122.5-99.3 221.8-221.8 221.8z"}})])
          )
        }
      }
    